import { Item, TicketItem, ValueItem } from "./entity";

export abstract class AnalyticsEventStructureProvider {

    public static getItem(overrides?: Partial<Item>): Item {
        return {
            item_id: "-",
            item_name: "-",
            index: 0,
            ...overrides,
        }
    }

    public static getValueItem(overrides?: Partial<ValueItem>): ValueItem {
        return {
            ...this.getItem(),
            price: 0,
            quantity: 0,
            ...overrides,
        }
    }

    public static getTicketItem(overrides?: Partial<TicketItem>): TicketItem {
        const overrideClone: Partial<TicketItem> = {...overrides };

        return {
            ...this.getValueItem(),
            coupon: "-",
            discount: 0,
            item_category: "-",
            item_category2: "-",
            item_list_id: "-",
            item_list_name: "-",
            item_partner_id: "-",
            item_partner_name: "-",
            item_event_organizer_id: "-",
            item_event_organizer_name: "-",
            item_event_date: "-",
            item_days_to_event: 0,
            item_event_city: "-",
            item_event_venue: "-",
            item_artist_id: "-",
            item_artist_name: "-",
            item_seat_selection: "-",
            item_eventseries_id: "-",
            item_eventseries_name: "-",
            item_variant: "-",
            ...overrideClone,
        }
    }
}
